import { ClaudeTemplate } from "../types";

export const redditTemplate: ClaudeTemplate = {
  id: "reddit",
  tool: "Reddit Ads",
  url: "https://ads.reddit.com/",
  hierarchy: "Business → Ad account → Campaign → Ad group → Ads",
  idHint: "ID de la campaña en el listado o en la URL al abrirla",
  accountField: "redditAdAccountIds",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre Reddit Ads ({{url}}). Si ya está abierto, sigue.
2. Elige la **Ad account** de {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscala por nombre; si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, "New campaign":
   - Objective según {{goal.kpi}}: CPM → Brand awareness and reach; CPC → Traffic; CPV → Video views; CPE → Engagement; CPL → Lead generation; CPA → Conversions.
   - Campaign name: {{names.order}}
   - Campaign budget optimization: desactivado (el presupuesto va en el ad group).

### 3. Ad group
1. Ad group name: {{names.line}}
2. Targeting: ubicación {{target.geography}} (país {{goal.country}}), edad {{target.age}}, sexo {{target.gender}}, idioma {{target.language}}, dispositivos {{target.technology}}.
3. Comunidades e intereses: {{target.interests}}. Audiencias: {{target.audience}}. Exclusiones: {{target.exclusions}}.
4. Placements: según el tipo de campaña {{campaignType}} (feed y/o conversaciones). CONVERSATION_ADS → solo conversaciones. Si el tipo es AMA, es una acción especial con Reddit: para y pregunta.
5. Budget & schedule: lifetime {{goal.budget}}, del {{goal.startDate}} al {{goal.endDate}}.
6. Bid: automático por defecto; si las notas piden coste controlado, puja manual en torno a {{goal.netUnitCost}}.

### 4. Ads
1. Formato según {{campaignType}}: FREE_FORM_ADS → free-form; IMAGE_ADS → imagen; VIDEO_ADS → vídeo; CAROUSEL_ADS → carrusel; PRODUCT_ADS → catálogo de producto (si no hay catálogo conectado, para y pregunta).
2. Piezas: bloque "Creatividades". Headline, texto y CTA: bloque "Copies". URL de destino con UTM: bloque "URLs de destino".
3. Perfil que publica: el de {{brand}} / {{client}}.
4. Deja la campaña **en pausa**. No la lances sin mi confirmación.
`,
};
